module.exports = __webpack_public_path__ + "img/upoint.3662cb7c.png";